var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.accountGetIsEnabled && _vm.hasSubscriptionEnabled
    ? _c("subscriptions")
    : _vm.accountGetIsEnabled &&
      _vm.isCheckoutV2Enabled &&
      !_vm.hasSubscriptionEnabled
    ? _c("items-only")
    : _vm.accountGetIsEnabled && _vm.isCheckoutV2Enabled
    ? _c("payment-link")
    : _vm.accountGetIsEnabled
    ? _c("items")
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }